import { memo, useRef, useEffect } from 'react';
import { useCanvasStores, useCanvasRotation } from '../stores/CanvasContext';

function CanvasTransformLayerInner({ children }: { children: React.ReactNode }) {
  const { panZoomStore } = useCanvasStores();
  const actualRotation = useCanvasRotation();
  const canvasRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const rot = actualRotation;
    function update() {
      const el = canvasRef.current;
      if (!el) return;
      const { panX, panY, zoom } = panZoomStore.getSnapshot().context;
      el.style.transform = rot === 0
        ? `translate(${panX}px, ${panY}px) scale(${zoom})`
        : `translate(${panX}px, ${panY}px) scale(${zoom}) rotate(${rot}deg)`;
      el.dataset.zoom = String(zoom);
    }
    update();
    const sub = panZoomStore.subscribe(update);
    return () => sub.unsubscribe();
  }, [panZoomStore, actualRotation]);

  return (
    <div
      ref={canvasRef}
      data-canvas-canvas
      style={{
        transformOrigin: '0 0',
        position: 'absolute',
        left: 0,
        top: 0,
        width: 50000,
        height: 50000,
      }}
    >
      {children}
    </div>
  );
}

export const CanvasTransformLayer = memo(CanvasTransformLayerInner);
